/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
import dayjs from 'dayjs';

const MaterialTransactionProcessColumn = [
  {
    label: 'ลำดับที่',
    value: 'index',
  },
  {
    label: 'เลขที่รายการ',
    value: 'running_number',
  },
  {
    label: 'วันที่ดำเนินการ',
    value: (row) => dayjs(row?.createdAt).format('D/MM/BBBB'),
  },
  {
    label: 'เวลาที่ดำเนินการ',
    value: (row) => dayjs(row?.createdAt).format('HH:mm'),
  },
  {
    label: 'คำสั่งผลิต',
    value: (row) =>
      row?.process_number?.manufacturing_order?.running_number || '-',
  },
  {
    label: 'รหัสลูกค้า',
    value: (row) =>
      row?.process_number?.manufacturing_order?.customer?.type_code || '-',
  },
  {
    label: 'ชื่อลูกค้า',
    value: (row) =>
      row?.process_number?.manufacturing_order?.customer?.name || '-',
  },
  {
    label: 'รหัสวัตถุดิบ',
    value: (row) => row?.lotId?.material?.type_code || '-',
  },
  {
    label: 'ชื่อวัตถุดิบ',
    value: (row) => row?.lotId?.material?.name || '-',
  },
  {
    label: 'ปริมาณวัตถุดิบที่เบิก',
    value: (row) => row?.quantity || '-',
  },
  {
    label: 'คงเหลือ',
    value: (row) => row?.amount || '-',
  },
  {
    label: 'หน่วยวัตถุดิบ',
    value: (row) => row?.lotId?.material?.unit || '-',
  },
  {
    label: 'พนักงาน',
    value: (row) => row?.request_name || '-',
  },
];

export default MaterialTransactionProcessColumn;
